import { render, staticRenderFns } from "./NearCommercial.vue?vue&type=template&id=382e2fcd"
import script from "./NearCommercial.vue?vue&type=script&lang=js"
export * from "./NearCommercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports